import type {
  BaseEvent,
  GeoPlugin,
  UserPlugin,
  ViewPlugin,
} from "@dndbeyond/event-pipeline-lib/shared";

import { getPlatform } from "../helpers/platform";
import type {
  ClickElementInput,
  ClickElementPlugin,
  CommonEventFields,
  EventContext,
} from "./types";

export const CLICK_ELEMENT_MESSAGE_NAME = "CLICK_ELEMENT";

/**
 * CLICK_ELEMENT EVENT
 * Fires when a user clicks an interactive element
 * https://wizardsofthecoast.atlassian.net/wiki/spaces/D3/pages/815498811/Click+Element+v2
 */
export const buildClickElementEvent = ({
  elementName,
  elementType,
  details,
  pageCategory,
  elementId,
  region,
  subscriptionLevel,
  ipAddress,
  userId,
  sessionId,
  visitorId,
  pageUrl,
  pagePath,
  location,
}: ClickElementInput & CommonEventFields & EventContext): BaseEvent => {
  const userPlugin: UserPlugin = {
    userId,
    subscriptionLevel,
    sessionId,
    visitorId,
  };

  const geoPlugin: GeoPlugin = {
    region,
    ipAddress,
  };

  const viewPlugin: ViewPlugin = {
    current: pageUrl,
  };

  const clickElementPlugin: ClickElementPlugin = {
    pageId: pagePath,
    changeLocation: location ?? null,
    pageCategory,
    elementName,
    elementType,
    elementId,
    details,
  };

  return {
    messageName: CLICK_ELEMENT_MESSAGE_NAME,
    platform: getPlatform(),
    plugins: [userPlugin, geoPlugin, viewPlugin, clickElementPlugin],
  };
};
